import api from './api'

export const authService = {
  register: (userData) => api.post('/accounts/register/', userData),
  login: (credentials) => api.post('/accounts/login/', credentials),
  getProfile: () => api.get('/accounts/profile/'),
  updateProfile: (data) => api.put('/accounts/profile/update/', data),
  changePassword: (data) => api.post('/accounts/change-password/', data),
}

export const courseService = {
  getAllCourses: (params) => api.get('/courses/', { params }),
  getCourse: (id) => api.get(`/courses/${id}/`),
  createCourse: (data) => api.post('/courses/create/', data),
  updateCourse: (id, data) => api.patch(`/courses/${id}/update/`, data),
  getMyCourses: () => api.get('/courses/my-courses/'),
  enrollCourse: (id) => api.post(`/courses/${id}/enroll/`),
  getEnrollments: () => api.get('/courses/enrollments/'),
  getCategories: () => api.get('/courses/categories/'),
  getCourseStudents: (id) => api.get(`/courses/${id}/students/`),
  getLessons: (courseId) => api.get(`/courses/${courseId}/lessons/`),
  createLesson: (courseId, data) =>
    api.post(`/courses/${courseId}/lessons/`, data),
  deleteLesson: (courseId, lessonId) =>
    api.delete(`/courses/${courseId}/lessons/${lessonId}/`),
  markLessonComplete: (courseId, lessonId) =>
    api.post(`/courses/${courseId}/lessons/${lessonId}/complete/`),
  getUserProgress: (courseId) => api.get(`/courses/${courseId}/my-progress/`),
}

export const assignmentService = {
  getAssignments: () => api.get('/assignments/'),
  getAssignment: (id) => api.get(`/assignments/${id}/`),
  createAssignment: (data) => api.post('/assignments/create/', data),
  getCourseAssignments: (courseId) =>
    api.get(`/assignments/course/${courseId}/`),
  createCourseAssignment: (courseId, data) =>
    api.post(`/assignments/course/${courseId}/`, data),
  deleteAssignment: (id) => api.delete(`/assignments/${id}/delete/`),
  submitAssignment: (id, data) => api.post(`/assignments/${id}/submit/`, data),
  getMySubmissions: () => api.get('/assignments/submissions/'),
  getAssignmentSubmissions: (id) => api.get(`/assignments/${id}/submissions/`),
  gradeSubmission: (id, data) =>
    api.patch(`/assignments/submissions/${id}/grade/`, data),
}

export const quizService = {
  getQuizzes: () => api.get('/quizzes/'),
  getQuiz: (id) => api.get(`/quizzes/${id}/`),
  createQuiz: (data) => api.post('/quizzes/create/', data),
  getCourseQuizzes: (courseId) => api.get(`/quizzes/course/${courseId}/`),
  createCourseQuiz: (courseId, data) =>
    api.post(`/quizzes/course/${courseId}/`, data),
  deleteQuiz: (id) => api.delete(`/quizzes/${id}/delete/`),
  startQuiz: (id) => api.post(`/quizzes/${id}/start/`),
  submitQuiz: (id, data) => api.patch(`/quizzes/attempts/${id}/submit/`, data),
  getMyAttempts: () => api.get('/quizzes/attempts/'),
  getQuizAttempts: (id) => api.get(`/quizzes/${id}/attempts/`),
  // Question management
  getQuizQuestions: (quizId) => api.get(`/quizzes/${quizId}/questions/`),
  createQuestion: (quizId, data) =>
    api.post(`/quizzes/${quizId}/questions/`, data),
  updateQuestion: (questionId, data) =>
    api.put(`/quizzes/questions/${questionId}/`, data),
  deleteQuestion: (questionId) =>
    api.delete(`/quizzes/questions/${questionId}/`),
  // Answer management
  getQuestionAnswers: (questionId) =>
    api.get(`/quizzes/questions/${questionId}/answers/`),
  createAnswer: (questionId, data) =>
    api.post(`/quizzes/questions/${questionId}/answers/`, data),
  updateAnswer: (answerId, data) =>
    api.put(`/quizzes/answers/${answerId}/`, data),
  deleteAnswer: (answerId) => api.delete(`/quizzes/answers/${answerId}/`),
}
